var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 194,
    viewBox: "0 0 216 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 181,
    transform: "translate(166 12.2024)",
    fill: "#FFCE4B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 117,
    transform: "translate(83 76.2024)",
    fill: "#FFCE4B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 61,
    transform: "translate(0 132.202)",
    fill: "#FFCE4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 121.703C29.5 99.7033 50.3 53.7032 107.5 67.7032C113.333 40.8701 135.4 -12.5973 191 4.2027",
    stroke: "#FFCE4B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 4.70239,
    r: 2.5,
    fill: "#FFCE4B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 67.7024,
    r: 2.5,
    fill: "#FFCE4B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 124.702,
    r: 2.5,
    fill: "#FFCE4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.30e87f4412ddd0b0d753e83d8a04f30f.svg";
export { ForwardRef as ReactComponent };